function filterImagesByAltText(variantTitle) {
  const allMediaItems = document.querySelectorAll('.product-gallery__media');
  const matchText = variantTitle.trim().toLowerCase();

  allMediaItems.forEach((media) => {
    const image = media.querySelector('img');
    if (!image) return;

    const altText = image.alt.trim().toLowerCase();
    if (altText.includes(matchText)) {
      media.style.display = '';
    } else {
      media.style.display = 'none';
    }
  });
}

function initializeVariantGalleryFilter() {
  const variantSelector = document.querySelector('select[name="id"]');
  if (!variantSelector) return;

  const applyFilter = () => {
    const selectedText = variantSelector.options[variantSelector.selectedIndex].text;
    filterImagesByAltText(selectedText);
  };

  applyFilter();
  variantSelector.addEventListener('change', applyFilter);
}

// Shopify Sections & Live Renders beachten:
document.addEventListener('DOMContentLoaded', initializeVariantGalleryFilter);
document.addEventListener('shopify:section:load', initializeVariantGalleryFilter);
document.addEventListener('shopify:section:unload', initializeVariantGalleryFilter);
